import { useEffect, useState } from "react";
import { VIDEO_STATS_API } from "../utils/contants";
import { formatNumber } from "../utils/helper";

const ChannelCard = ({videoId}) =>{

    const [views,setViews] = useState(0);
    const [likes,setLikes] = useState(0);
    

    useEffect(()=>{
        getVideoStats();
    }, [videoId]);

    const getVideoStats = async () =>{
        const data = await fetch(VIDEO_STATS_API+videoId);
        const json = await data.json();
        setLikes(json?.items[0]?.statistics?.likeCount);
        setViews(json?.items[0]?.statistics?.viewCount);
    }
    return (
        <div className="flex shadow-sm bg-gray-100 p-2 rounded-lg my-2 md:w-[60%] w-[99%]">
            <p className="px-2 text-xl font-bold text-black py-2">Top Statistics - </p>
            <p className="px-2 mx-4 border border-gray-900 rounded-2xl bg-white-400 font-bold text-blue-500 py-2">
                Likes - {formatNumber(likes)}
            </p>
            <p className="px-2 border border-blue-500 rounded-2xl bg-white-400 font-bold text-black py-2">Views - {formatNumber(views)}</p>
        </div>
    )
};
export default ChannelCard;